export enum LEAD_TYPE {
  Concierge = 'Concierge',
  Marketplace = 'Marketplace',
}

export enum INTENT {
  buy = 'buy',
  quote = 'quote',
  interest = 'interest',
}

export enum TERNARY {
  YES = 'YES',
  NO = 'NO',
  MAYBE = 'MAYBE',
}

export enum ATTACHMENT_TYPE {
  SWITCHBOARD = 'SWITCHBOARD',
  ELECTRICITY_BILL = 'ELECTRICITY_BILL',
  GAS_BILL = 'GAS_BILL',
}

export enum PURCHASE_PRIORITY {
  BEST_BRANDS_PERFORMANCE = 'best_brands_performance',
  QUALITY_FAIR_PRICE = 'quality_fair_price',
  KEEPING_COSTS_DOWN = 'keeping_costs_down',
  OPEN_TO_RECOMMENDATIONS = 'open_to_recommendations',
}
